import { Model } from '.';

export class UserInvitationResend extends Model {
  public apiPath = undefined;
  public className = 'resend';
}
